import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Box,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { SGamenMenu } from "components/parts";
import { useRecoilState } from "recoil";
import { menusState, turnOpenMenu } from "states";

type Props = {
  closeDrawer: Function;
};

export const SGyomuMenu = (props: Props) => {
  const [menus, setMenus] = useRecoilState(menusState);
  return (
    <List component="nav">
      {Object.keys(menus)
        .sort()
        .map((gyomuId, index) => {
          const menu = menus[gyomuId];
          const handleClick = (gyomuId: string) => {
            turnOpenMenu(gyomuId, menus, setMenus);
          };
          return (
            <Box key={gyomuId}>
              <ListItem
                key={gyomuId}
                button
                disableGutters
                onClick={() => handleClick(gyomuId)}
                sx={{ paddingLeft: "8px" }}
              >
                <ListItemText primary={menu.label} />
                {menu.open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Divider />
              <Collapse
                in={menu.open}
                timeout="auto"
                component="li"
                unmountOnExit
              >
                <SGamenMenu
                  pages={menu.pages}
                  closeDrawer={props.closeDrawer}
                />
              </Collapse>
            </Box>
          );
        })}
    </List>
  );
};
